import React from 'react';
import { CATEGORY_TONES, DEFAULT_TONE, TYPE_TONES } from '../constants/statuses';
import { useI18n } from '../i18n';

export default function SoftTag({ children, tone = DEFAULT_TONE, style }) {
  return (
    <span
      className="soft-status-tag"
      style={{
        '--tag-color': tone.color,
        '--tag-bg': tone.background,
        '--tag-border': tone.border,
        ...style,
      }}
    >
      {children}
    </span>
  );
}

export function ClientTypeTag({ status }) {
  const { t } = useI18n();
  const tone = CATEGORY_TONES[status] || { ...DEFAULT_TONE, label: status };
  return <SoftTag tone={tone}>{t(tone.label)}</SoftTag>;
}

export function OfferTypeTag({ type }) {
  const { t } = useI18n();
  const tone = TYPE_TONES[type] || DEFAULT_TONE;
  return <SoftTag tone={tone}>{t(type)}</SoftTag>;
}
